import * as React from 'react';
import { ChatTimelineMessage } from '../types';
import { classNames } from '../../../../../common/utils';
import { TinyLoader } from '@wix/answers-ui-libby';

export const imageTimelineKey = 'image-timeline';
export type ImageTimelineProps = {
	item: ChatTimelineMessage;
};

export type ImageTimelineState = {
	isLoaded: boolean
};

export class ImageTimeline extends React.PureComponent<ImageTimelineProps, ImageTimelineState> {

	state: ImageTimelineState = {
		isLoaded: false
	};

	onImageLoaded = () => this.setState({isLoaded: true});

	renderImage = (item: ChatTimelineMessage) => {
		const data = item.chatMessageData;
		const image = data ? data.attachments[0] : null;

		const imageNames = classNames('image', {
			loaded: this.state.isLoaded
		});

		const onClick = () => {
			parent.postMessage({imageSrc: image && image.url}, '*');
		};

		return (
			image ? (
			<div className='image-content'>
				{!this.state.isLoaded ? <TinyLoader/> : null}
				<img onClick={onClick} className={imageNames} src={image.url} onLoad={this.onImageLoaded}/>
			</div>
			) : null
		);
	}

	render () {
		const item = this.props.item;
		return (
			this.renderImage(item)
		);
	}
}
